import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    getAll(context, params) {
      return new Promise((resolve, reject) => {
        axios.get('http://localhost:8881/backtester/carteira',
          {
            params,
            headers: {
              token: '1227c0d4-22d1-15ec-9721-2227ac130002',
            },
          })
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

    atualizar(context, payload) {
      return new Promise((resolve, reject) => {
        axios.put('http://localhost:8881/backtester/carteira/atualizar', payload,
          {
            headers: {
              token: '1227c0d4-22d1-15ec-9721-2227ac130002',
            },
          })
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

    executar(context, params) {
      return new Promise((resolve, reject) => {
        axios.put('http://localhost:8881/backtester/carteira/executar', null,
          {
            params,
            headers: {
              token: '1227c0d4-22d1-15ec-9721-2227ac130002',
            },
          })
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

    excluir(context, params) {
      return new Promise((resolve, reject) => {
        axios.delete('http://localhost:8881/backtester/carteira/excluir', {
          params,
          headers: {
            token: '1227c0d4-22d1-15ec-9721-2227ac130002',
          },
        })
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

    getCarteira(context, id) {
      return new Promise((resolve, reject) => {
        axios.get(`http://localhost:8881/backtester/carteira/consulta-id/${id}`, {
          headers: {
            token: '1227c0d4-22d1-15ec-9721-2227ac130002',
          },
        })
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

  },
}
